/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Register_Create_AccountInputs */

const en_auth_register_create_account = /** @type {(inputs: Auth_Register_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const es_auth_register_create_account = /** @type {(inputs: Auth_Register_Create_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una cuenta`)
};

/**
* | output |
* | --- |
* | "Create an account" |
*
* @param {Auth_Register_Create_AccountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_register_create_account = /** @type {((inputs?: Auth_Register_Create_AccountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Register_Create_AccountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_register_create_account(inputs)
	return es_auth_register_create_account(inputs)
});